
import { useState, useEffect } from 'react';

export default function ScrollToTopButton() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  if (!isScrolled) return null;

  return (
    <div className="hidden md:flex fixed right-6 bottom-8 z-50">
      <button
        onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
        className="w-12 h-12 bg-white text-[#222222] rounded-full shadow-lg flex items-center justify-center cursor-pointer border border-gray-200 hover:bg-gray-50 transition-colors"
      >
        <i className="ri-arrow-up-line text-xl"></i>
      </button>
    </div>
  );
}
